import { App } from "vue";

const requireDirective = require.context(
  // The relative path of the components folder
  "./",
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match component files
  /\.*\.ts$/
);

const register = (app: App<Element>): void => {
  requireDirective.keys().forEach((fileName) => {
    // Get directive config
    const directiveConfig = requireDirective(fileName);

    // Get directive name
    const directiveName = fileName
      .split("/")
      .pop()
      ?.replace(/\.\w+$/, "") as string;

    app.directive(directiveName, directiveConfig.default || directiveConfig);
  });
};

export default {
  register,
};
